import { useState } from "react";
import ContentZero from "../../../componets/Erp/ContentZero";
import ContentFirst from "../../../componets/Erp/ContentFirst";
import ContentSecond from "../../../componets/Erp/ContentSecond";
import ContentThird from "../../../componets/Erp/ContentThird";
import ContentFourth from "../../../componets/Erp/ContentFourth";
import ContentFifth from "../../../componets/Erp/ContentFifth";
import ContentSixth from "../../../componets/Erp/ContentSixth";
import ContentSeventh from "../../../componets/Erp/ContentSeventh";
import ContentEight from "../../../componets/Erp/ContentEight";
import ContentNinth from "../../../componets/Erp/ContentNinth";
import ContentTenth from "../../../componets/Erp/ContentTenth";
import "./index.css";

export default function Section2() {
  const [verticalTabsState, setVerticalTabsState] = useState(0);

  const verticalTabsList = [
    "point of sale",
    "sales",
    "crm",
    "accounting",
    "invoicing",
    "inventory",
    "human resources",
    "purchase management",
    "manufacturing",
    "fleet management",
    "pos for restaurants",
  ];

  const handleTabState = (index) => {
    setVerticalTabsState(index);
  };

  return (
    <div className="w-full Section2 py-[35px]">
      <div className="container-1280 section2-container text-[#535353] w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h1 className="text-[#da2128] font-bold text-[24px] leading-[30px] md:text-[34px] md:leading-[40px] my-[0.67em]">
          Enterprise Resource Planning
        </h1>
        <h4 className="text-[16px] leading-[28px] font-open my-[10px]">
          Mean3 ERP is an all-in-one management software that offers a wide
          range of business applications that form a complete suite of
          enterprise management applications targeting companies of all sizes.
          This software includes CRM, Website/e-Commerce, billing, accounting,
          manufacturing, warehouse- and project management, and inventory.
        </h4>
        <div className="pt-[35px]">
          <div className="flex flex-col md:flex-row tabs font-open">
            <div className="md:w-[20%] vertical-tabs-wrapper overflow-x-auto md:overflow-x-visible">
              <ul className="vertical-tabs text-[#8f8f8f] pb-3 inline-block whitespace-nowrap md:whitespace-normal md:block md:w-full">
                {verticalTabsList.map((title, index) => {
                  return (
                    <li
                      onClick={() => handleTabState(index)}
                      key={title}
                      className={`vertical-tab-item inline-block md:block leading-[22px] text-[16px] p-[14px_20px] md:p-[10px_20px_10px_0] -mr-[1px]  uppercase transition-colors duration-[0.2s] ease-out hover:text-[#cd2122] cursor-pointer ${
                        verticalTabsState === index
                          ? "text-[#cd2122] bg-[#fbfbfb] md:bg-none md:border-r-[4px] md:border-solid md:border-[#cd2122]"
                          : ""
                      }`}
                    >
                      {title}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="tab-content-wrapper pt-6 md:pt-0 md:pl-[30px] md:w-[80%] md:border-l md:border-solid md:border-[#c2c2c2] text-[#535353]">
              <div className="relative tab-content">
                <ContentZero verticalTabsState={verticalTabsState} />

                <ContentFirst verticalTabsState={verticalTabsState} />

                <ContentSecond verticalTabsState={verticalTabsState} />

                <ContentThird verticalTabsState={verticalTabsState} />

                <ContentFourth verticalTabsState={verticalTabsState} />

                <ContentFifth verticalTabsState={verticalTabsState} />

                <ContentSixth verticalTabsState={verticalTabsState} />

                <ContentSeventh verticalTabsState={verticalTabsState} />

                <ContentEight verticalTabsState={verticalTabsState} />

                <ContentNinth verticalTabsState={verticalTabsState} />

                <ContentTenth verticalTabsState={verticalTabsState} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
